"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconText["default"];
  }
});
var _IconText = _interopRequireDefault(require("./IconText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }